// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"522b4313","667":"281c87b5","977":"6fdbf558"}[chunkId] + ".chunk.js";
};